import React, {useContext} from 'react';

import {AppContext} from '../../../AppModule/Context';

import CommunicationIcons from '../../../assets/svgComponents/communicationIcons';
import MessageCue from '../../common/messageCue/messageCue';
import WidgetTitleComponent from './widgetTitleComponent';

import VIDABOO_CONSTANTS from '../../../config/consts';

import './actionSelector.css';

const ActionSelector = ({
  isDemo,
  foregroundWidgets,
  headerText,
  onFooterOptionSelected,
  widgetEditableTexts,
}) => {
  const context = useContext(AppContext);

  const getCommunicationTabLanguageSpecificText = (selectedWidgetAppType) => {
    const editableTexts = widgetEditableTexts || {};
    const widgetKey = `CHANNEL_${selectedWidgetAppType}`;
    let customText = editableTexts[widgetKey];

    if (customText) return customText;

    switch (selectedWidgetAppType) {
      case VIDABOO_CONSTANTS.WIDGET_APP_TYPES.TEXT_CHAT:
        return context.languageSet.CONSOLTO_WIDGET.CHAT;
      case VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WEBCALL:
        return context.languageSet.CONSOLTO_WIDGET.WEBCALL;
      case VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WHATSAPP:
        return context.languageSet.CONSOLTO_WIDGET.WHATSAPP;
      case VIDABOO_CONSTANTS.WIDGET_APP_TYPES.FB_MESSENGER:
        return context.languageSet.CONSOLTO_WIDGET.MESSENGER;
      case VIDABOO_CONSTANTS.WIDGET_APP_TYPES.CUSTOM_LINK:
        return context.languageSet.CONSOLTO_WIDGET.CUSTOM_LINK;
      case VIDABOO_CONSTANTS.WIDGET_APP_TYPES.PHONE_CALL:
        return context.languageSet.CONSOLTO_WIDGET.PHONE;
      case VIDABOO_CONSTANTS.WIDGET_APP_TYPES.INFO_COLLECTOR:
        return context.languageSet.CONSOLTO_WIDGET.CONTACT;
      case VIDABOO_CONSTANTS.WIDGET_APP_TYPES.SCHEDULE_MEETING:
        return context.languageSet.CONSOLTO_WIDGET.SCHEDULE;
      default:
        return '';
    }
  };

  const getIconType = (selectedWidgetAppType) => {
    switch (selectedWidgetAppType) {
      case VIDABOO_CONSTANTS.WIDGET_APP_TYPES.TEXT_CHAT:
        return 'ChatIcon';
      case VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WEBCALL:
        return 'VideoIcon';
      case VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WHATSAPP:
        return 'WhatsappIcon';
      case VIDABOO_CONSTANTS.WIDGET_APP_TYPES.FB_MESSENGER:
        return 'MessengerIcon';
      case VIDABOO_CONSTANTS.WIDGET_APP_TYPES.CUSTOM_LINK:
        return 'CustomLinkIcon';
      case VIDABOO_CONSTANTS.WIDGET_APP_TYPES.PHONE_CALL:
        return 'PhoneIcon';
      case VIDABOO_CONSTANTS.WIDGET_APP_TYPES.INFO_COLLECTOR:
        return 'FormIcon';
      case VIDABOO_CONSTANTS.WIDGET_APP_TYPES.SCHEDULE_MEETING:
        return 'ScheduleIcon';
      default:
        return '';
    }
  };

  return (
    <div className="et-action-selector-container">
      <div className="et-action-list-header">
        <WidgetTitleComponent
          title={headerText ? headerText : 'Select how we talk'}
        />
      </div>
      <div className="et-as-list-wrap">
        {foregroundWidgets &&
          foregroundWidgets.map((fgWidget, index) => {
            const CommunicationTab = CommunicationIcons[getIconType(fgWidget)];
            return (
              <div
                key={index}
                className="et-asl-list-item"
                onClick={() => {
                  onFooterOptionSelected(fgWidget);
                }}>
                <div className="et-as-tab-icon-msg-cue-wrap">
                  {!isDemo &&
                    fgWidget === VIDABOO_CONSTANTS.WIDGET_APP_TYPES.TEXT_CHAT &&
                    context.showChatCue && <MessageCue />}
                  <CommunicationTab showNewUI />
                </div>
                <div className="et-asl-text">
                  {getCommunicationTabLanguageSpecificText(fgWidget)}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default ActionSelector;
